export default __webpack_public_path__ + "static/media/HENNESSY_4.9c5c3e96.gif";